module.exports = __webpack_public_path__ + "static/media/icons8-home.b99b3676.svg";